// All home page related apis
import { BASEURL } from './api';
import instance from './api';
import { encryptData } from '../helpers/encryptDecrypt';
const API_URL = BASEURL+'/api/home';

// Get api for fetching one weeks sales realted data for active organization and active branch
export const fetchHomeSalesData = async (organization_id, branch_id) => {
  const oId = encryptData(organization_id);
  const bId = encryptData(branch_id);
  return await instance.get(`${API_URL}/sales?organizationId=${oId}&branchId=${bId}`);
};

// Get customer related counts data for active organization
export const fetchHomeCustomerData = async (organization_id) => {
  const oId = encryptData(organization_id);
  return await instance.get(`${API_URL}/customers?organizationId=${oId}`);
};

// Get api for fetching highlighted products for showcase in homepage
export const fetchHomeProductData = async (organization_id, branch_id) => {
  const oId = encryptData(organization_id);
  const bId = encryptData(branch_id);
  return await instance.get(`${API_URL}/products?organizationId=${oId}&branchId=${bId}`);
};